(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaltify-home-giftfinder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#julegavefinder"]');
  const finder = document.querySelector('#julegavefinder .zgf-card');
  if (!link || !finder) return;
  event.preventDefault();
  const align = (behavior) => {
  const header = document.querySelector('header-component');
  const inset = (header?.getBoundingClientRect().height || 0) + 16;
  const viewport = window.visualViewport?.height || window.innerHeight;
  const rect = finder.getBoundingClientRect();
  const space = Math.max(0, (viewport - inset - rect.height) / 2);
  window.scrollTo({top: window.scrollY + rect.top - inset - space, behavior});
  };
  align(matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
  const observer = new ResizeObserver(() => align('instant'));
  observer.observe(document.querySelector('#MainContent'));
  setTimeout(() => observer.disconnect(), 2200);
});

  } catch(e) { console.error(e); }
})();
})();
